import { Filter } from "./filter";

export class Active extends Filter {
  constructor() {
    super("active");
  }
}
